<div *ngIf="becare.authenticated">
    <div [ngClass]="{ 'legacy-content-hidden' : !isLegacy }" id="content" style="left:60px;z-index:2;height: calc(-122px + 100vh);overflow: scroll;">
        <div id="contentel" [innerHtml]="content"></div>
    </div>
    <div [ngClass]="{ 'component-content-hidden' : isLegacy }" style="width:100%;overflow: scroll;background-color: white;">
        <ng-template #itemContainer></ng-template>
    </div>
</div>